"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSectionList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * <mm-content-section-list>
 * 페이지의 구획을 세로로 쌓고 구획 사이 간격만 책임지는 그룹 컨테이너입니다.
 * 자식은 mm-content-section이 기본이지만 제목 없는 구획(배너·격자 등)도 같은 간격으로 함께 쌓습니다.
 * 간격은 섹션 간격 토큰 하나로 정해지며 소비처가 고르지 않습니다.
 */
let ContentSectionList = class ContentSectionList extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
ContentSectionList.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-section);
    }
  `;
ContentSectionList = __decorate([
    (0, decorators_js_1.customElement)('mm-content-section-list')
], ContentSectionList);
exports.ContentSectionList = ContentSectionList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC1zZWN0aW9uLWxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb250ZW50LXNlY3Rpb24tbGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpEOzs7OztHQUtHO0FBRUksSUFBTSxrQkFBa0IsR0FBeEIsTUFBTSxrQkFBbUIsU0FBUSxnQkFBVTtJQVNoRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFaTSx5QkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7R0FNbEIsQ0FBQTtBQVBVLGtCQUFrQjtJQUQ5QixJQUFBLDZCQUFhLEVBQUMseUJBQXlCLENBQUM7R0FDNUIsa0JBQWtCLENBYzlCO0FBZFksZ0RBQWtCIn0=